type LoginQueryParams = Readonly<Record<string, string>>;

export const appLoginUrl = (): string => "/login";

export const marketingLoginUrl = (
  campaign: string,
  extraParams: LoginQueryParams = {}
): string => {
  const attributionParams = new URLSearchParams({
    utm_source: "marketing",
    utm_medium: "cta",
    utm_campaign: campaign,
    ...extraParams,
  });

  return `${appLoginUrl()}?${attributionParams.toString()}`;
};
